import { render, staticRenderFns } from "./YesOrNoView.vue?vue&type=template&id=04028a5e"
import script from "./YesOrNoView.vue?vue&type=script&lang=js"
export * from "./YesOrNoView.vue?vue&type=script&lang=js"
import style0 from "./YesOrNoView.vue?vue&type=style&index=0&id=04028a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports